import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const PageLayout = ({ children, title = '', noCard = false }) => {
  const maxWidth = '1200px'; // Fixed width for all pages
  const footerHeight = '180px'; // Height of the fixed footer
  const navbarHeight = '80px'; // Height of the fixed navbar

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      width: '100%',
      backgroundColor: 'background.default',
      position: 'relative',
      paddingBottom: `calc(${footerHeight} + 2rem)`
    }}>
      <Box sx={{
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        pt: navbarHeight, // Add navbar height padding
        ...(noCard ? {
          py: 0,
          paddingBottom: `calc(${footerHeight} + 2rem)`
        } : {
          py: 4,
          paddingBottom: `calc(${footerHeight} + 4rem)`
        })
      }}>
        <Container 
          maxWidth={false} 
          sx={{ 
            width: '100%', 
            maxWidth: maxWidth, 
            px: noCard ? 0 : { xs: 2, sm: 3, md: 4 },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            ...(noCard ? {
              '& > .MuiBox-root': {
                width: '100%',
                p: 0,
                borderRadius: 0,
                boxShadow: 'none',
                mb: 0,
                backgroundColor: 'transparent',
                maxWidth: '100%',
                boxSizing: 'border-box'
              }
            } : {
              '& > .MuiBox-root': {
                width: '100%',
                p: { xs: 2, sm: 3 },
                borderRadius: 2,
                boxShadow: 1,
                mb: 4,
                backgroundColor: 'transparent',
                maxWidth: '100%',
                boxSizing: 'border-box'
              }
            })
          }}
        >
          {title && (
            <Typography 
              variant="h4" 
              component="h1" 
              gutterBottom
              sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' },
                textAlign: 'center',
                mb: { xs: 3, sm: 4 },
                fontWeight: 600,
                width: '100%'
              }}
            >
              {title}
            </Typography>
          )}
          {noCard ? (
            <Box sx={{ width: '100%' }}>
              {children}
            </Box>
          ) : (
            <Box sx={{ width: '100%' }}>
              {children}
            </Box>
          )}
        </Container>
      </Box>
    </Box>
  );
};

export default PageLayout;
